export type CrispBootstrap = {
  website_id: string;
  token?: string;
  email_signature?: string;
};

export const configureCrispForUser = (
  email: string,
  firstName: string,
  bootstrap?: CrispBootstrap
) => {
  if (!bootstrap || !bootstrap.website_id || !window.$crisp) {
    return;
  }

  if (bootstrap.token && bootstrap.email_signature) {
    // Crisp applies a token set after l.js is loaded on the following reset.
    (window as any).CRISP_TOKEN_ID = bootstrap.token;
    window.$crisp.push(["do", "session:reset"]);
    window.$crisp.push(["set", "user:email", [email, bootstrap.email_signature]]);
  } else {
    window.$crisp.push(["set", "user:email", [email]]);
  }

  window.$crisp.push(["set", "user:nickname", [firstName]]);
};

export const resetCrispSession = () => {
  if (!window.$crisp) {
    return;
  }

  (window as any).CRISP_TOKEN_ID = undefined;
  window.$crisp.push(["do", "session:reset"]);
};
